import { baseApi } from '@/lib/utils'

export interface Skill {
  id: number
  name: string
  is_system: 0 | 1 | boolean
  created_at: string
  updated_at: string
}

export interface SkillsResponse {
  success: boolean
  data: Skill[]
}

export interface ApiSuccess {
  success: boolean
  message?: string
  data?: unknown
}

export const skillsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSkills: builder.query<SkillsResponse, void>({
      query: () => ({ url: '/skills' }),
      providesTags: result =>
        result
          ? [
              ...result.data.map(s => ({ type: 'Skills' as const, id: s.id })),
              { type: 'Skills' as const, id: 'LIST' },
            ]
          : [{ type: 'Skills' as const, id: 'LIST' }],
    }),
    createSkill: builder.mutation<
      { success: boolean; message: string; data: Skill },
      { name: string }
    >({
      query: body => ({ url: '/skills', method: 'POST', body }),
      invalidatesTags: [{ type: 'Skills', id: 'LIST' }],
    }),
    updateSkill: builder.mutation<ApiSuccess, { id: number; name: string }>({
      query: ({ id, name }) => ({
        url: `/skills/${id}`,
        method: 'PATCH',
        body: { name },
      }),
      // Renames cascade into employees.skills on the server, so the employees
      // list also has to refetch.
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Skills', id },
        { type: 'Skills', id: 'LIST' },
        'Employees',
      ],
    }),
    deleteSkill: builder.mutation<ApiSuccess, number>({
      query: id => ({ url: `/skills/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Skills', id: 'LIST' }, 'Employees'],
    }),
  }),
})

export const {
  useGetSkillsQuery,
  useCreateSkillMutation,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
} = skillsApi
